import Layout from '@eduzz/houston-ui/Layout';
import { updateIntercom } from 'intercom';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { from, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { VERTICAL_URL } from 'settings';
import eduzzAccountsService from 'v2/services/eduzzAccount';

import { MenuRoute } from './MenuRoute';
import { routes } from './routes';

import type { Route } from './routes';

const { Sidebar } = Layout;

function NavBar() {
  const location = useLocation();
  const [verticalRoutes] = useObservable(
    () =>
      eduzzAccountsService.getUserVertical().pipe(
        switchMap((user) => {
          return from(import('@myeduzz-vertical/root/menu').then((d) => d.default(user as any)));
        }),
        map((menus) => {
          return menus.map<Route>((menu) => ({
            label: menu.name,
            nodes: menu.items.map((item) => {
              const to = item.path.startsWith('/') ? `${VERTICAL_URL}${item.path}` : item.path.replace(/^http.+\/producer\//gim, '/producer/');

              return {
                label: item.name,
                to,
              };
            }),
          }));
        }),
        catchError(() => of(routes))
      ),
    []
  );

  React.useEffect(() => {
    updateIntercom();
  }, [location.pathname, location.search]);

  return (
    <Sidebar currentLocation={location.pathname}>
      {verticalRoutes?.map((route) => (
        <MenuRoute key={route.to} route={route} />
      ))}
    </Sidebar>
  );
}

export { NavBar };
